import { fetchApi, type GenericRes } from '@hunk/shared/api/fetchApi';
import type { RoleType, TelegramUser } from '@hunk/shared/common';
import type { PublicUserEntity } from '@hunk/shared/schema';

export interface LoginRes extends GenericRes {
  token?: string;
  /** only for the Mini App login */
  tgUser?: TelegramUser;
  user?: PublicUserEntity;
  role?: RoleType;
}

/** Telegram Mini App login (inside Telegram) */
export interface LoginReq {
  /** Telegram.WebApp.initData (raw query string) */
  initDataRaw: string;
}
export const login = ({ data, headers }: { data: LoginReq; headers?: HeadersInit }) => fetchApi<LoginReq, LoginRes>({ apiPath: '/api/auth/login', method: 'POST', data, headers });

/** email login, step 1: send a 6-digit code to the address (one per address per 3 minutes) */
export interface EmailCodeReq {
  email: string;
  /** the solved captcha (ALTCHA widget payload, challenge from CAPTCHA_URL) */
  captcha: string;
}
export const CAPTCHA_URL = '/api/auth/captcha';
export interface EmailCodeRes extends GenericRes {
  /** seconds before another code can be asked for */
  resendAfterSec?: number;
}
export const requestEmailCode = ({ data }: { data: EmailCodeReq }) => fetchApi<EmailCodeReq, EmailCodeRes>({ apiPath: '/api/auth/email/code', method: 'POST', data });

/** email login, step 2: the code -> session (the user is created on the first login) */
export interface EmailVerifyReq {
  email: string;
  code: string;
}
export const verifyEmailCode = ({ data }: { data: EmailVerifyReq }) => fetchApi<EmailVerifyReq, LoginRes>({ apiPath: '/api/auth/email/verify', method: 'POST', data });

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const EMAIL_CODE_LENGTH = 6;

/** which login methods the server offers (the login page shows only those) */
export interface AuthInfoReq {}
export interface AuthInfoRes extends GenericRes {
  /** "Log in with Telegram" on the website (OAuth); the button goes to TELEGRAM_LOGIN_URL */
  telegramWeb: boolean;
  /** email one-time code (SMTP configured, or dev mode where the code is written to the server log) */
  email: boolean;
  /** why telegramWeb is false (diagnostics only, no secrets) */
  telegramWebReason?: string;
}
export const TELEGRAM_LOGIN_URL = '/api/auth/telegram/start';
export const authInfo = ({ headers }: { headers?: HeadersInit } = {}) => fetchApi<AuthInfoReq, AuthInfoRes>({ apiPath: '/api/auth/info', method: 'GET', headers });
